import { gql } from '@apollo/client';

export const CategoryFields = gql`
  fragment CategoryFields on Category {
    id
    name
    pluralName
    slug
    areaUnits
    photosRequired
    areRoomsRequired
    hasRepair
    hasBuildingType
    hasFloor
    hasLandArea
    hasRooms
  }
`;

export const CoreLocationFields = gql`
  fragment CoreLocationFields on Query {
    regions(cityId: 1) {
      id
      name
      slug
      __typename
    }
    cities(filter: { scope: UNPOPULAR }, limit: 80) {
      id
      name
      slug
      __typename
    }
  }
`;
